import axios from "../../utils/axios";

async function addDriver(data) {
  return await axios.post(`/single/drivers`, data);
}

async function updatDriver(data, driverId) {
  return await axios.patch(`/single/drivers/${driverId}`, data);
}
async function deleteDriver(driverId) {
  return await axios.delete(`/single/drivers/${driverId}`);
}

async function getDrivers(params) {
  return await axios.get(`/single/drivers`, { params });
}

async function getDriverById(driverId) {
  return await axios.get(`/single/drivers/${driverId}`);
}

async function updateDriveActiveStatus(driverId, data) {
  return await axios.patch(`/single/drivers/${driverId}`, data);
}

async function updateDriverBalance(driverId, data) {
  return await axios.patch(`/single/drivers/${driverId}/updateBalance`, data);
}

export const Driver = {
  addDriver,
  updatDriver,
  deleteDriver,
  getDrivers,
  getDriverById,
  updateDriveActiveStatus,
  updateDriverBalance,
};
